module.exports = __webpack_public_path__ + "static/img/A82.fe90e78a.jpg";